import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import RegionNavigator from "../../../navigation/RegionNavigator";
import styles from "./regionSettings.module.css";

const RegionSettings = () => {
  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/regions/show-all-regions">
              عرض جميع المناطق
            </PageLink>
          </div>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/regions/add-new-region">
              اضافة منطقة جديدة
            </PageLink>
          </div>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/regions/edit-regions-images">
              التحكم في صور المناطق
            </PageLink>
          </div>
        </div>
      </HorizantalBar>
      <RegionNavigator />
    </div>
  );
};

export default RegionSettings;
